<!--
    课程统计-耗课情况
    功能：展示校区授权课程的耗课数据
    说明：版本3.0
-->
<template>
  <div
    v-loading="isLoading"
    class="auth-page">
    <div
      ref="top"
      class="top-demo">
      <search-form
        :is-query.sync="listQuery"
        :form-data="formData"
        :is-add="false"
        style="flex:1"
        @onSearch="handlerSearch"/>
      <div class="btn-block">
        <el-button
          :loading="downLoading"
          size="medium"
          type="primary"
          @click="handlerExcel">导出搜索数据</el-button>
      </div>
    </div>
    <el-table
      v-if="tableHeight"
      ref="table"
      :data="tableData"
      :height="tableHeight"
      class="table-demo"
      fit
      style="width: 100%;"
    >
      <el-table-column
        v-for="item in tableHead"
        :key="item.id"
        :label="item.label"
        :width="item.width"
        :min-width="item.minWidth"
        :prop="item.prop"
        :formatter="item.formatter"
      />
    </el-table>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      style="text-align: right;margin-top:20px"
      @current-change="getList"
    />
  </div>
</template>
<script>
import searchForm from '@/components/AppFilter';
import baseUrl from '@/utils/api';

export default {
  name: 'ConsumpSituation',
  components: {
    searchForm,
  },
  data() {
    return {

      total: 0,
      isLoading: false, // 是否加载
      tableData: [],
      tableHeight: null,
      listQuery: {
        page: 1,
        per_page: 10,
      },
      tableHead: [
        {
          label: '校区名称',
          minWidth: '100px',
          formatter: (row) => {
            const info = row.clients_review_info ? row.clients_review_info : '--';
            const name = info ? info.name : '--';
            return name;
          },
        },
        {
          label: '校区代码',
          minWidth: '100px',
          formatter: (row) => {
            const info = row.client ? row.client : '--';
            const code = info ? info.school_code : '--';
            return code;
          },
        },
        {
          label: '课程名称',
          minWidth: '100px',
          formatter: (row) => {
            const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';
            const name = park ? row.course_ware_packet_auth.packet.name : '--';
            return name;
          },
        },
        {
          prop: 'course_name',
          label: '课件名称',
          minWidth: '100px',
        },
        // {
        //   label: '课程编号',
        //   minWidth: '100px',
        //   formatter: (row) => {
        //     const park = row.course_ware_packet_auth ? row.course_ware_packet_auth.packet : '';
        //     const code = park ? row.course_ware_packet_auth.packet.code : '--';
        //     return code;
        //   },
        // },
        {
          label: '上课时间',
          minWidth: '150px',
          formatter: (row) => {
            const begin = row.begin_time ? row.begin_time : '-';
            const end = row.close_time ? row.close_time : '-';
            return `${begin} ~ ${end}`;
          },
        },
        {
          label: '上课状态',
          formatter: (row) => {
            const status = {
              1: '未开始',
              2: '上课中',
              3: '已结束',
              4: '缺课',
              5: '已取消',
            };
            return status[row.status];
          },
        },
        {
          prop: 'act_liveroom_second',
          label: '实际上课时长',
          minWidth: '100px',
          formatter: (row) => {
            let diff = '00:00:00';
            if (row.living_duration) {
              const time = this.$setting.setTime(row.living_duration);
              diff = `${this.timeFamate(Number(time.day || 0) * 24 + Number(time.hour))}:${time.min}:${time.sec}`;
            }
            return diff;
          },
        },
        {
          prop: 'teacher_name',
          label: '上课老师',
          minWidth: '100px',
        },
        {
          prop: 'liveroom_classes',
          label: '上课班级',
          minWidth: '160px',
        },
        {
          prop: 'student_count',
          label: '上课学生数',
          minWidth: '100px',
        },
        {
          prop: 'packet_number_consume',
          label: '耗课次数',
        },
        {
          label: '授权形式',
          minWidth: '100px',
          formatter: (row) => {
            const auth_type = row.course_ware_packet_auth ? row.course_ware_packet_auth.auth_type : '';
            let auth = '--';
            if (auth_type && auth_type === 1) auth = '账号形式';
            if (auth_type && auth_type === 2) auth = '次数形式';
            return auth;
          },
        },
        // {
        //   prop: 'course_title',
        //   label: '课件标题',
        //   minWidth: '100px',
        // },
        // {
        //   label: '剩余次数/截止有效期',
        //   minWidth: '100px',
        //   formatter: (row) => {
        //     const auth = row.course_ware_packet_auth;
        //     let auth_val = '--';
        //     if (auth && auth.auth_expire_time) auth_val = auth.auth_expire_time;
        //     if (auth && auth.auth_number) auth_val = auth.auth_number - auth.used_number;
        //     return auth_val;
        //   },
        // },
      ],
      dateVal: null,
      formData: [{
        typeName: 'daterange',
        startPlaceholder: '开始上课时间(起)',
        endPlaceholder: '开始上课时间(尾)',
      },
      {
        typeName: 'input',
        placeholder: '请输入课件名称',
        model: 'like[course_name]',
      },
      {
        typeName: 'inputSelectSearch',
        model: 'like[search_school_name]',
        options: [
          {
            value: 'like[search_school_name]',
            label: '校区名称',
          },
          {
            value: 'like[teacher_name]',
            label: '上课老师',
          },
          {
            value: 'like[auth_packet_name]',
            label: '课程名称',
          },
          {
            value: 'like[name]',
            label: '课件名称',
          }],
      },
      {
        typeName: 'select1',
        placeholder: '授权形式',
        model: 'equal[packet_auth_type]',
        options: [
          {
            value: 1,
            label: '账号形式',
          },
          {
            value: 2,
            label: '次数形式',
          },
        ],
      },
      {
        typeName: 'select1',
        placeholder: '上课状态',
        model: 'equal[status]',
        options: [
          { value: 1, label: '未开始' },
          { value: 2, label: '上课中' },
          { value: 3, label: '已结束' },
          { value: 4, label: '缺课' },
          { value: 5, label: '已取消' },
        ],
      },
      ],
      downLoading: false,
    };
  },
  mounted() {
    this.setTableHeight();
    this.getList();
    window.onresize = () => {
      setTimeout(() => {
        this.setTableHeight();
      }, 10);
    };
  },
  methods: {
    timeFamate(num) {
      return num > 9 ? num : `0${num}`;
    },
    setTableHeight() {
      this.tableHeight = window.innerHeight - this.$refs.top.offsetHeight - 120;
    },
    getList() {
      this.isLoading = true;
      const schoolId = this.$store.state.choicesSchool.id;
      const dateVal = this.dateVal;
      const api = dateVal ? `${baseUrl}/api/liveroom?packet_auth_school_id=${schoolId}&order[begin_time]=desc&between[created_at][]=${dateVal[0]}&between[created_at][]=${dateVal[1]}` : `${baseUrl}/api/liveroom?packet_auth_school_id=${schoolId}&order[begin_time]=desc`;
      this.$http.get(api, {
        params: { ...this.listQuery },
      }).then((res) => {
        this.tableData = res.items;
        this.total = res.meta.total;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    handlerSearch(date) {
      this.dateVal = date;
      this.listQuery.page = 1;
      this.getList();
    },
    handlerExcel() {
      const schoolId = this.$store.state.choicesSchool.id;
      const dateVal = this.dateVal;
      const fields = 'school_name,school_code,packet_name,course_name,live_time,live_status,living_duration,teacher_name,liveroom_classes,student_count,number_consume,packet_auth_type';
      const api = dateVal ? `${baseUrl}/api/liveroom?packet_auth_school_id=${schoolId}&action=export_excel&order[begin_time]=desc&between[created_at][]=${dateVal[0]}&between[created_at][]=${dateVal[1]}&excel_fields=${fields}` : `${baseUrl}/api/liveroom?packet_auth_school_id=${schoolId}&action=export_excel&order[begin_time]=desc&excel_fields=${fields}`;
      this.downLoading = true;
      this.$http.get(api, {
        responseType: 'blob',
        params: { ...this.listQuery },
      }).then((res) => {
        this.$setting.saveAs(res, '耗课统计');
      }).finally(() => {
        this.downLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.auth-page{
  height: 100vh;
  width: 100%;
  flex:none!important;
  box-sizing: border-box;
}
.top-demo{
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  .btn-block{
    width: 300px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/CourseStatistics/ConsumpSituation/index.vue